import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeId from '@angular/common/locales/id';
import localeEn from '@angular/common/locales/en';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

registerLocaleData(localeId, 'id');
registerLocaleData(localeEn, 'en');

if (environment.production) {
  enableProdMode();

  console.log(
    '%cStop!',
    'color: red; font-size: 65px; font-weight: bold; text-shadow: 2px 2px black;'
  );

  console.log(
    '%cThis is a browser feature intended for developers.\nIf someone told you to copy-paste something here, it could be a scam or security risk.\nDO NOT paste anything here unless you understand exactly what it does.',
    'color: white; font-size: 16px; font-weight: normal;'
  );
}
